<template>
  <header class="converter-header container-fluid py-2 shadow-sm">
    <div class="row align-items-center">
      <!-- Back Button -->
      <div class="col-auto">
        <button
          @click="$router.push({ name: pageViews.CONVERTERVIEW })"
          class="back-button btn btn-light rounded-circle shadow-sm"
          title="Back to Converter"
        >
          <i class="fa fa-arrow-left"></i>
        </button>
      </div>

      <!-- Title -->
      <div class="col text-center">
        <h5 class="header-title mb-0">{{ updatedTitle }}</h5>
      </div>

      <!-- Tabs -->
      <div class="col-auto" v-if="!isxmlDifferenceView">
        <ul class="nav nav-tabs header-tabs">
          <li class="nav-item">
            <router-link
              class="nav-link small"
              :to="{ name: 'XSLFileDifferenceView' }"
            >
              Compare
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link small"
              :to="{ name: 'XmlTransformView', params: routerParams }"
              @change="checkFileData()"
            >
              XML Transformer
            </router-link>
          </li>
        </ul>
      </div>

      <!-- Empty spacer when tabs hidden -->
      <div class="col-auto" v-else></div>
    </div>
  </header>
</template>

<script>
// import Store from '../vuex/store'
import {
  getSessionItem,
  setSessionItem,
  removeSessionItem,
} from "../../store/session.js";
import { useType } from "../../composables/useType.js";
import { pageViews, type } from "@/utils/util";
import { getTitle } from "@/services/apiServices";
import XMLFileDIfference from "../XMLFileDIfference.vue";
export default {
  name: "XmlandFileDifMenu",
  setup() {
    const { getType } = useType();
    return {
      getType,
      type,
      pageViews,
    };
  },
  computed: {
    convertedFileName: function () {
      // return Store.getters.getConvertedFileName;
      return getSessionItem("convertedFileName");
    },
    xslFileName: function () {
      return getSessionItem("xslFileName");
    },
    xmlFileName: function () {
      return getSessionItem("xmlFileName");
    },
    componentType: function () {
      return getSessionItem("componentType");
    },
    isxmlDifferenceView: function () {
      return this.diffView === type.XML;
    },
    routerParams: function () {
      return { ...this.$route.params, ...{ xslParamId: this.xslParamId } };
    },
    updatedTitle: function () {
      return this.title;
    },
  },
  data() {
    return {
      responseBody: "",
      loading: false,
      title: "",
    };
  },
  methods: {
    display() {
      console.log("After store file Name:", this.convertedFileName);
    },
    isActiveTab(tabName) {
      return this.$route.name === tabName;
    },
    async updateTitle(paramId) {
      if (paramId) {
        try {
          const typeParam = this.isxmlDifferenceView ? type.XML : type.XSL;
          const response = await getTitle(
            this.$acclConfigs,
            paramId,
            this.userId,
            typeParam
          );
          if (response.status == 200) {
            this.title = response.data.title;
          } else {
            console.error(
              `Failed to fetch title for ${typeParam}:`,
              response.data.message
            );
          }
        } catch (error) {
          console.error("Error making API call - getTitle()", error);
        }
      }
    },
  },
  watch: {
    "$props.xslParamId": {
      handler(paramId) {
        this.updateTitle(paramId); // Call updateTitle when params change
      },
      immediate: true,
    },
    "$props.xmlParamId": {
      handler(paramId) {
        this.updateTitle(paramId); // Call updateTitle when params change
      },
      immediate: true,
    },
  },
  unmounted() {
    setSessionItem("type", type.XSL);
  },
  props: ["projectParamId", "xslParamId", "xmlParamId", "diffView"],
};
</script>

<style scoped>
.converter-header {
  background-color: var(--surface);
  border-bottom: 1px solid var(--border-color);
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 2px 8px var(--shadow-soft);
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.back-button {
  border: 1px solid var(--border-color);
  background: var(--surface-hover);
  color: var(--primary);
  width: 38px;
  height: 38px;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.25s ease;
}
.back-button:hover {
  background-color: var(--primary);
  color: var(--surface);
  border-color: var(--primary);
  box-shadow: 0 0 6px var(--shadow-strong);
}

.header-title {
  font-weight: 600;
  color: var(--text-primary);
  letter-spacing: 0.3px;
  transition: color 0.3s ease;
}

.header-tabs {
  border-bottom: none;
  gap: 0.25rem;
}

.header-tabs .nav-link {
  color: var(--text-secondary);
  border: 1px solid transparent;
  padding: 6px 10px;
  border-radius: 6px 6px 0 0;
  transition: all 0.2s ease;
  
}
.header-tabs .nav-link {
  background-color: var(--primary-bg);
  color: var(--primary);
  border: 1px solid var(--text-secondary);
}


.header-tabs .router-link-exact-active {
  background-color: var(--primary);
  color: var(--surface);
  font-weight: 500;
  border-color: var(--primary);
}
</style>
